// TODO, DEPRECATED, remove!!!!!
import classNames from 'classnames';
import * as React from 'react';
import shortid from 'shortid';

import { TextField } from 'components/Fields/Input';

type Value = nil | number | string;

type Props = {
  name: string;
  value: Value;
  label: string;
  autoFocus?: boolean;
  applyFilter?: (
    arg0: {
      [K in string]: Value;
    },
  ) => void;
};

type State = {
  value: Value;
};

class InputFilter extends React.Component<Props, State> {
  id: string;

  state: State = {
    value: '',
  };

  constructor(props: Props) {
    super(props);
    this.id = shortid();
    this.state = {
      value: props.value,
    };
  }

  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    this.setState({
      value,
    });
  };

  keyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      this.applyFilter();
    }
  };

  applyFilter = () => {
    const { applyFilter } = this.props;
    applyFilter && applyFilter({ [this.props.name]: this.state.value });
  };

  clear = () => {
    this.setState({
      value: null,
    });
  };

  render() {
    const { name, label } = this.props;
    const { value } = this.state;
    return (
      <div className='filter-container'>
        <div className='form-group' onKeyUp={this.keyPress}>
          <TextField
            label={label}
            fullWidth
            id={this.id}
            value={`${!!value ? value : ''}`}
            errors={[]}
            name={name}
            onChange={this.onChange}
            autoFocus
          />
        </div>
        <div className='filter-control'>
          <span className={classNames('clear', { hidden: !value })} onClick={this.clear}>
            Clear
          </span>
          <span className='apply' onClick={this.applyFilter}>
            Apply
          </span>
        </div>
      </div>
    );
  }
}

export { InputFilter };
